import React from "react";

export const SearchFormWarning = ({ invalid, message }) => {
  return invalid ? (
    <p className="text-danger font-small mb-2">{message}</p>
  ) : (
    ""
  );
};
